/**
 * Modelo de classe para representar a senha.
 */
export class Senha {
    novaSenha: any;
}
